import { render, staticRenderFns } from "./consumable.vue?vue&type=template&id=635ea22e&scoped=true&"
import script from "./consumable.vue?vue&type=script&lang=js&"
export * from "./consumable.vue?vue&type=script&lang=js&"
import style0 from "./consumable.vue?vue&type=style&index=0&id=635ea22e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635ea22e",
  null
  
)

export default component.exports